import Link from '@components/primitives/Link'
import { type Url } from '@lib/routes'
import Button, { type ButtonProps } from './index'

/**
 * @deprecated Please use <Link /> styled with buttonClassNames.variant.color
 * @example
 * <Link href="/" className={buttonClassNames.variant.color}>
 *   Click me
 * </Link>
 */
export const LinkButton = (
  props: ButtonProps & {
    href: Url
    linkClassName?: string
    linkPrefetch?: boolean
    newTab?: boolean
    rel?: string
  },
) => {
  return (
    <Link
      className={props.linkClassName}
      href={props.href}
      newTab={props.newTab}
      prefetch={props.linkPrefetch}
      rel={props.rel}
      suppressHydrationWarning
    >
      <Button {...props} />
    </Link>
  )
}
